import CustomerModel from "@src/backbone/model/CustomerModel";

import { HappyHourMessage } from "../types/HappyHour.interface";

/**
 * Fonction utilitaire pure pour vérifier la visibilité d'un message Happy Hour
 */
export function isHappyHourMessageVisible(
  message: HappyHourMessage | undefined
): boolean {
  const active = message?.active;
  if (!message || !active) return false;

  return true;
}
